import { Route, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/App.css';
import { withCookies } from 'react-cookie';
import React, { PureComponent } from 'react';
import HomeComponent from './HomeComponent';
import LoginComponent from './admin/LoginComponent';
import DashboardComponent from './admin/DashboardComponent';
import PaymentSuccessContainer from '../containers/PaymentSuccessContainer';
import PaymentFailComponent from './PaymentFailComponent';
import OrderConfirmComponent from './OrderConfirmComponent';
import DriverRegistrationComponent from './driver/DriverRegistrationComponent';

class App extends PureComponent {
  render() {
    return (
      <>
        <Switch>
          <Route exact path="/">
            <HomeComponent />
          </Route>
          <Route path="/success">
            <PaymentSuccessContainer />
          </Route>
          <Route path="/fail">
            <PaymentFailComponent />
          </Route>
          <Route path="/order/update">
            <OrderConfirmComponent />
          </Route>
          <Route exact path="/admin/login">
            <LoginComponent cookies={this.props.cookies} />
          </Route>
          <Route exact path="/admin/dashboard">
            <DashboardComponent cookies={this.props.cookies} />
          </Route>
          <Route exact path="/driver">
            <DriverRegistrationComponent />
          </Route>
        </Switch>
      </>
    );
  }
}

export default withCookies(App);
